module.exports = __webpack_public_path__ + "img/img_propuesta_portada.c65889c0.jpg";